import { connect } from 'react-redux';

import Header from './component';
import { toggleHeader, closeHeader } from '../../redux/ducks/globalUi';

const mapStateToProps = (state, ownProps) => ({
  isOpen: state.globalUi.isHeaderOpen,
  navItems: ownProps.navItems,
  currentLocation: ownProps.currentLocation,
});

const mapDispatchToProps = dispatch => ({
  handleMenuToggle: (event) => {
    event.preventDefault();
    dispatch(toggleHeader());
  },
  handleMenuItemClick: () => {
    dispatch(closeHeader());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./blocks/Header/container.js